import type { HoComponents } from '@pos/api-client';

export type ListItem = HoComponents['schemas']['SegmentListItem'];

/** One pasted line as a list entry (ADR 0080): an email, a phone (digits, spaces, + . ( ) -), else a member account number. */
export function toListItem(line: string): ListItem | null {
  const value = line.trim();
  if (!value) return null;
  if (value.includes('@')) return { type: 'email', value };
  if (/^[+\d][\d\s.()-]{6,}$/.test(value)) return { type: 'phone', value };
  return { type: 'account', value };
}
